import React from 'react'

const NotFoundPage = () => {
  return (
    <>
    <div>
      <h1 className='m-lg-5'>404</h1>
      <h3>Nothing here!</h3>
    </div>
    </>
  )
}

export default NotFoundPage